import React, { useCallback, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import { mergeDeepRight, mergeRight, remove } from "ramda";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { isBlank, mapIndexed, notBlank } from "../../util/ext";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import { makeStyles } from "@material-ui/core/styles";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import SubmissionTypesDialog from "../edit/SubmissionTypesDialog";
import EditIcon from "@material-ui/icons/Edit";
import { expandDisplayName } from "../cspServices";
import { caseInsensitiveSort } from "../../util/sorts";
import ConfirmButton from "../../components/ConfirmButton";

const useStyles = makeStyles(theme => ({
  header: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  content: {
    paddingTop: 0,
  },
}));

const sortSubmissionTypes = caseInsensitiveSort("displayName");

const SubmissionTypesCard = ({ project, loading, onUpdate }) => {
  const classes = useStyles();

  const [dialogOpen, setDialogOpen] = useState(false);
  const handleAddClick = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleCancel = useCallback(() => {
    setDialogOpen(false);
  }, []);

  const handleDialogApply = useCallback(
    async data => {
      //call parent callback to save updated data.
      setDialogOpen(false);
      console.log(data);
      const update = mergeRight(project, { submissionTypes: data });
      console.log(update);
      onUpdate(update);
    },
    [project, onUpdate],
  );
  const handleDeleteClick = useCallback(
    async idx => {
      const update = mergeDeepRight(project, {
        submissionTypes: remove(
          idx,
          1,
          sortSubmissionTypes(project.submissionTypes),
        ),
      });
      onUpdate(update);
    },
    [project, onUpdate],
  );

  return (
    <Card raised elevation={4} style={{ height: "100%" }}>
      <CardHeader
        titleTypographyProps={{
          color: "primary",
          variant: "h6",
        }}
        title="Submission Types"
        action={
          <Tooltip title="Add Submission Types">
            <IconButton onClick={handleAddClick}>
              <EditIcon color="primary" fontSize="large" />
            </IconButton>
          </Tooltip>
        }
        classes={{ root: classes.header }}
      />
      <CardContent classes={{ root: classes.content }}>
        {loading && <PanelLoadingIndicator />}
        {isBlank(project) && (
          <Box padding={5} fontSize="1.4rem" fontStyle="italic">
            Error Loading Submission Types.
          </Box>
        )}
        {isBlank(project.submissionTypes) && (
          <Box padding={5} fontSize="1.4rem" fontStyle="italic">
            No Submission Types set up for this Project.
          </Box>
        )}
        {notBlank(project.submissionTypes) && (
          <List dense>
            {mapIndexed(
              (st, idx) => (
                <ListItem key={st.name}>
                  <ListItemText primary={expandDisplayName(st)} />
                  <ListItemSecondaryAction>
                    <ConfirmButton
                      handleDelete={() => handleDeleteClick(idx)}
                      dialogTitle="Remove Submission Type"
                      dialogBody="Are you sure you want to remove this submission type?"
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              ),
              sortSubmissionTypes(project.submissionTypes),
            )}
          </List>
        )}
      </CardContent>

      {dialogOpen && (
        <SubmissionTypesDialog
          project={project}
          open={dialogOpen}
          onCancel={handleCancel}
          onApply={handleDialogApply}
        />
      )}
    </Card>
  );
};

export default SubmissionTypesCard;
